import React from 'react';

import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";

import { Wrapper, Content, WrapperBox, ContentBox, Head, HeadContent, Title, WrapIcon } from "./styles";

export const AccordionWrapper = ({ title, children }) => {

    return (
        <Wrapper>
            <Head>
                <Title>{title}</Title>
            </Head>
            <Content>
                {children}
            </Content>
        </Wrapper>
    )
}

export const AccordionBox = ({ title, children }) => {

    const [panel, setPanel] = React.useState(false);

    const handlePanel = () => {
        setPanel(old => !old)
    }

    return (
        <WrapperBox>
            <HeadContent onClick={handlePanel}>
                <Title>{title}</Title>
                <WrapIcon>
                    <Icon icon={panel ? ["fas", "chevron-up"] : ["fas", "chevron-down"]} />
                </WrapIcon>
            </HeadContent>
            {panel && (
                <ContentBox className="accordion-children">
                    {children}
                </ContentBox>
            )}
        </WrapperBox>
    )
}